import React, {Component} from "react";
import {withNamespaces} from "react-i18next";

class DaliHelvarAreaForm extends Component {

    state = {
        form: {
            id: null,
            label: "",
            deviceGroupId: null,
            networkDeviceId: null,
        },
        isEdit: false,
    };

    componentDidMount() {
        if (!this.props.data) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    networkDeviceId: parseInt(this.props.deviceId),
                    deviceGroupId: this.props.deviceGroups[0].id
                }
            })
        }

        if(this.props.data) {
            const {data} = this.props;
            this.setState({
                ...this.state,
                isEdit: true,
                form: {
                    id: data.id,
                    label: data.label,
                    deviceGroupId: data.deviceGroupId,
                    networkDeviceId: data.networkDeviceId
                }
            })
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleSelect = (e) => {
        e.preventDefault();
        const deviceGroupId = parseInt(e.target.value);
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name] : deviceGroupId,
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.submitForm(this.state.form);
    };

    render() {
        const { t, deviceGroups } = this.props;
        const selectDom = deviceGroups ? ( deviceGroups?.map((item) => {
            return (
                <option key={item.id} value={item.id}> {item.label} </option>
            )
        })) : ( <option value={null}>Loading ...</option> );

        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label className="col-form-label">{t('label')}</label>
                        <input
                            className='form-control'
                            name="label"
                            title="label"
                            value={this.state.form.label || ''}
                            onChange={this.handleOnChangeInput}
                            required={true}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="deviceType">{ t('single-device-group') }</label>
                        <select className="form-control" name="deviceGroupId" value={this.state.form.deviceGroupId || -1} onChange={this.handleSelect}>
                            { !selectDom || selectDom }
                        </select>
                    </div>

                    <div className="form-group float-right">
                        { this.state.isEdit ? (
                            <button type="submit" className={"btn btn-primary" }>
                                <i className="fas fa-edit"> </i> {t('edit')}
                            </button>
                        ) : (
                            <button type="submit" className={"btn btn-success" }>
                                <i className="fas fa-plus"> </i> {t('create')}
                            </button>
                        ) }
                    </div>
                </form>
            </div>
        );
    }
}
export default withNamespaces()(DaliHelvarAreaForm);
